"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// Foundation Dropdown is being used as a substitute for ToolTip since links in ToolTip bodies aren't interactive
// it is recommended by Foundation Docs video to use Dropdown instead: https://get.foundation/sites/docs/tooltip.html
exports.default = (function (_a) {
    var button = _a.button, children = _a.children;
    var dropdownId = (0, react_1.useMemo)(function () { return new Date().getTime(); }, []);
    var closeDropdownFnName = "closeDropdown".concat(dropdownId);
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var dropdownElement = ref.current;
        if (dropdownElement) {
            var dropDown_1 = new Foundation.Dropdown($(dropdownElement));
            window[closeDropdownFnName] = function () { return dropDown_1.close(); };
            return function () {
                dropDown_1.destroy();
            };
        }
    }, []);
    return (react_1.default.createElement("span", { className: 'bundle-items-dropdown' },
        react_1.default.createElement("a", { "data-toggle": "id-".concat(dropdownId) }, button),
        react_1.default.createElement("div", { className: 'dropdown-pane', "data-close-on-click": 'true', "data-position": 'bottom', "data-alignment": 'center', id: "id-".concat(dropdownId), "data-dropdown": true, "data-auto-focus": 'true', ref: ref },
            react_1.default.createElement("div", { className: 'position-relative' },
                react_1.default.createElement("a", { href: "javascript:".concat(closeDropdownFnName, "()"), className: 'position-absolute top-0 right-0' },
                    react_1.default.createElement("i", { className: 'ss-delete text-gray lh1', style: { fontSize: 26 } })),
                children))));
});
